import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/common/BreadCrumb";
import { useLocation, useNavigate } from "react-router-dom";
import {
  createServiceByReport,
  getServiceById,
} from "../../redux/service/slice";
import { useDispatch, useSelector } from "react-redux";
import RippleLoader from "../../components/RippleLoader/RippleLoader";
import Action from "../../components/common/Action";
import ReactSelect from "react-select";
import { BackArrow, DownArrowAction } from "../../assets/svg";

const ViewService = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedYear, setSelectedYear] = useState(null);
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(true);
  const serviceData = location?.state?.service;
  const [isCompletedOpen, setIsCompletedOpen] = useState(true);
  const toggleCompletedTable = () => {
    setIsCompletedOpen(!isCompletedOpen);
  };
  const toggleTable = () => {
    setIsOpen(!isOpen);
  };

  const currentYear = new Date().getFullYear();
  const startYear = 2000;

  const yearOptions = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => {
      const year = currentYear - i;
      return { value: year.toString(), label: year.toString() };
    }
  );

  // Selector
  const { getServiceListData, loading } = useSelector((store) => ({
    getServiceListData:
      store?.serviceData?.getServiceByIdStatus?.data?.data?.data,
    loading: store?.serviceData?.loading,
  }));

  useEffect(() => {
    if (serviceData?.id) {
      dispatch(
        getServiceById({
          id: serviceData?.id,
          year: selectedYear?.value ?? "",
        })
      );
    }
  }, [serviceData?.id, selectedYear?.value]);

  const service = getServiceListData?.[0];

  const handleViewReport = async (saleId, type) => {
    try {
      const res = await dispatch(
        createServiceByReport({ id: saleId, type: type })
      );
      if (res?.payload?.download_url) {
        window.open(res?.payload?.download_url, "_blank");
      }
    } catch (err) {
      console.error("Error viewing report:", err);
    }
  };

  const handleDownloadReport = (saleId, type) => {
    dispatch(createServiceByReport({ id: saleId, type: type })).then((res) => {
      const fileUrl = res?.payload?.download_url;

      if (fileUrl) {
        fetch(fileUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok.");
            }
            return response.blob();
          })
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            const fileName = fileUrl.split("/").pop() || "document.pdf";

            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
          })
          .catch((err) => {
            console.error("Error fetching file:", err);
          });
      } else {
        console.error("Download URL not found");
      }
    });
  };

  const DataRows = () => {
    return (
      <>
        {service?.next_Upcoming_Appointment?.map((element, index) => (
          <tr
            key={index}
            className="font-normal text-sm shadow-sm text-mgrey font-Proxima"
          >
            <td className="px-5 py-3">{index + 1}</td>
            <td className="px-5 py-3">{element?.name || "-"}</td>
            <td className="px-5 py-3">{element?.date_time || "-"}</td>
          </tr>
        ))}
      </>
    );
  };

  const CompletedDataRows = () => {
    return (
      <>
        {service?.completed_Service_Request?.map((element, index) => (
          <tr
            key={index}
            className="font-normal text-sm shadow-sm text-mgrey font-Proxima"
          >
            <td className="px-5 py-3">{index + 1}</td>
            <td className="px-5 py-3">{element?.name || "-"}</td>
            <td className="px-5 py-3">{element?.date_time || "-"}</td>
            <td className="flex px-5 py-3">
              <Action
                optionList={
                  <>
                    <li
                      className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                      onClick={() => {
                        handleViewReport(element?.service_report_id, "report");
                      }}
                    >
                      View
                    </li>
                    <li
                      className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                      onClick={() => {
                        handleDownloadReport(
                          element?.service_report_id,
                          "report"
                        );
                      }}
                    >
                      Download
                    </li>
                  </>
                }
              />
            </td>
          </tr>
        ))}
      </>
    );
  };

  return (
    <>
      {loading ? (
        <RippleLoader />
      ) : (
        <div>
          <div>
            <h6 className="font-Montserrat font-medium text-xl mb-3">
              Service Request
            </h6>
            <Breadcrumb
              breadCrumbParent={"Home"}
              breadCrumbParent2={"Service Request Scheduling"}
              breadCrumbActive={"company"}
              breadCrumbTitleKey={"/"}
              classes=""
            />
          </div>
          <div className="flex items-center justify-between px-4 md:px-8">
            <div className="pt-3 flex justify-between gap-5 items-center">
              <div
                className="cursor-pointer"
                onClick={() => navigate("/services")}
              >
                <BackArrow />
              </div>
              <p className="sm:text-2xl text-base font-Montserrat font-normal">
                {service?.outlet_name || "No Outlet Name"}
              </p>
            </div>
            {/* Year Dropdown */}
            <div className="w-40">
              <ReactSelect
                className="w-full max-w-52 text-black p-0 font-Proxima"
                id="year"
                placeholder="Year"
                options={yearOptions}
                isClearable={true}
                value={selectedYear}
                onChange={(option) => {
                  setSelectedYear(option);
                }}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    border: `1px solid #0000003B`,
                    borderColor:
                      state.isFocused || selectedYear ? "#F15B29" : "#0000003B",
                    borderRadius: "0.3rem",
                    boxShadow: "none",
                    "&:hover": {
                      border: "1px solid #0000003B",
                    },
                  }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isSelected ? "#F15B29" : "white",
                    color: state.isSelected ? "white" : "black",
                    "&:active": {
                      backgroundColor: state.isSelected
                        ? "#F15B29"
                        : "rgba(0, 0, 0, 0.04)",
                    },
                  }),
                }}
              />
            </div>
          </div>
          {loading ? (
            <RippleLoader />
          ) : (
            <>
              <div className="p-4 md:p-8 bg-gray-50 lg:flex gap-6">
                {/* Header controls */}
                <div className="lg:flex lg:flex-col mb-4 gap-4 w-full lg:max-w-md max-w-sm">
                  {/* Stats */}
                  <div className="flex w-full rounded-lg">
                    <div className="bg-lightTheme border border-mediumGrey rounded-tl-xl rounded-bl-xl shadow-sm p-4 w-1/2">
                      <p className="text-sm text-black">Service Done</p>
                      <p className="text-darkGrey text-sm">Total Count</p>
                      <p className="text-xl font-semibold">
                        {service?.service_count}
                      </p>
                    </div>
                    <div className="bg-bgService border border-mediumOrange rounded-tr-xl rounded-br-xl shadow-sm p-4 w-1/2">
                      <p className="text-sm text-black">Repair Done</p>
                      <p className="text-darkGrey text-sm">Total Count</p>
                      <p className="text-xl font-semibold">
                        {service?.repair_count}
                      </p>
                    </div>
                  </div>
                  {/* First Table Section */}
                  <div className=" lg:mt-0 mt-5 bg-white p-6 rounded-lg shadow-md mb-6 border border-borderDot overflow-auto">
                    <div className="bg-successGreen rounded p-2 flex justify-between items-center">
                      <p className="text-md font-normal text-mgrey">
                        Next Upcoming Appointment
                      </p>
                      <div className="cursor-pointer p-2">
                        <button onClick={toggleTable}>
                          <DownArrowAction
                            className={`transform transition-transform duration-300 ${
                              isOpen ? "rotate-180" : "rotate-0"
                            } text-darkGrey`}
                          />
                        </button>
                      </div>
                    </div>

                    {/* Toggle Table */}
                    {isOpen && (
                      <div className="mt-2">
                        <table className="w-full table-auto text-left border-t border-borderDot">
                          <tbody>{DataRows()}</tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>

                {/* Appointments and Completed Request */}
                <div className="">
                  {/* second */}
                  <div className="bg-bgGrey p-6 rounded-lg shadow-md mb-6 border border-borderDot  overflow-auto">
                    <div className="bg-background_grey rounded p-3 flex justify-between items-center">
                      <p className="text-md font-normal text-mgrey mr-6">
                        Completed Service Request
                      </p>
                      <button onClick={toggleCompletedTable}>
                        <DownArrowAction
                          className={`transform transition-transform duration-300 ${
                            isCompletedOpen ? "rotate-180" : "rotate-0"
                          } text-darkGrey`}
                        />
                      </button>
                    </div>

                    {/* Toggle Table */}
                    {isCompletedOpen && (
                      <div className="mt-2">
                        <table className="w-full table-auto text-left border-t border-borderDot">
                          <tbody>{CompletedDataRows()}</tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default ViewService;
